export default __webpack_public_path__ + "static/media/T0692-Formulario-de-solicitud-de-medicamentos-de-diabetes.a37c4438.pdf";